// ADD HERE NEW LANGUAGES
export const languages = [
  {
    lang: "it",
    description: "Italiano",
  },
  {
    lang: "en",
    description: "Inglese",
  },
  {
    lang: "de",
    description: "Tedesco",
  },
  {
    lang: "fr",
    description: "Francese",
  },
  {
    lang: "es",
    description: "Spagnolo",
  },
];
